import { AxiosResponse } from "axios";
import { axiosCoreInstance } from "../../AxiosCoreInterceptor";
import { Deviations, DeviationsDto } from "../../../Model/Dto/EmploymentEquity/Deviations";
import { SearchResult } from "../../../Model/Dto/SearchResult";
import * as ApiUrls from "./ApiUrl.Deviations";

export const DeviationsService = {
    GetHeatmapSummary: (scorecardId: string): Promise<AxiosResponse<DeviationsDto.HeatmapSummaryDto>> =>
        axiosCoreInstance.get(ApiUrls.GetHeatmapSummary, { params: { scorecardId } }),

    GetPlanSummary: (scorecardId: string): Promise<AxiosResponse<DeviationsDto.PlanSummaryDto>> =>
        axiosCoreInstance.get(ApiUrls.GetPlanSummary, { params: { scorecardId } }),

    GetPlanSummaryMovementIndividuals: (request: DeviationsDto.PlanSummaryMovementIndividualsRequest): Promise<AxiosResponse<SearchResult<DeviationsDto.PlanSummaryMovementIndividualDto>>> =>
        axiosCoreInstance.post(ApiUrls.GetPlanSummaryMovementIndividuals, request),

    GetRecruitmentPromotionMovements: (request: DeviationsDto.RecruitmentPromotionMovementsRequest): Promise<AxiosResponse<DeviationsDto.RecruitmentPromotionMovementsResultDto>> =>
        axiosCoreInstance.post(ApiUrls.GetRecruitmentPromotionMovements, request),

    SearchJustifications: (request: Deviations.SearchRequest): Promise<AxiosResponse<SearchResult<Deviations.SearchResultDto>>> =>
        axiosCoreInstance.post(ApiUrls.SearchJustifications, request),

    GetById: (scorecardId: string, id: number): Promise<AxiosResponse<Deviations.DtoOut>> =>
        axiosCoreInstance.get(ApiUrls.GetDeviationById(scorecardId, id)),

    Create: (dto: Deviations.DtoIn): Promise<AxiosResponse<Deviations.DtoOut>> =>
        axiosCoreInstance.post(ApiUrls.CreateDeviation, dto),

    Update: (dto: Deviations.DtoIn): Promise<AxiosResponse<Deviations.DtoOut>> =>
        axiosCoreInstance.put(ApiUrls.UpdateDeviation, dto),

    Delete: (scorecardId: string, id: number): Promise<AxiosResponse<void>> =>
        axiosCoreInstance.delete(ApiUrls.DeleteDeviationById(scorecardId, id)),
    
    GetJustificationSummary: (scorecardId: string): Promise<AxiosResponse<DeviationsDto.DeviationsJustificationSummaryDto>> =>
        axiosCoreInstance.get(ApiUrls.GetJustificationSummary, { params: { scorecardId } }),
};
